import { lightColor, darkColor } from './Colors';
import { pxToRem } from '../Helpers';

const baseProperties = {
  fontFamily: 'Open Sans, sans-serif',
  fontFamily2: 'Nunito, sans-serif',
  fontWeightLighter: 100,
  fontWeightLight: 300,
  fontWeightRegular: 400,
  fontWeightMedium: 600,
  fontWeightBold: 700,
  fontSizeXXS: pxToRem(10.4),
  fontSizeXS: pxToRem(12),
  fontSizeSM: pxToRem(14),
  fontSizeMD: pxToRem(16),
  fontSizeLG: pxToRem(18),
  fontSizeXL: pxToRem(20),
  fontSize2XL: pxToRem(24),
  fontSize3XL: pxToRem(30),
};

const baseHeadingPropertiesLight = {
  color: lightColor.dark.main,
  fontWeight: baseProperties.fontWeightBold,
};

const baseDisplayPropertiesLight = {
  fontFamily: baseProperties.fontFamily,
  color: lightColor.dark.main,
  fontWeight: baseProperties.fontSizeSM,
};

const baseHeadingPropertiesDark = {
  color: darkColor.light.main,
  fontWeight: baseProperties.fontWeightBold,
};

const baseDisplayPropertiesDark = {
  fontFamily: baseProperties.fontFamily,
  color: darkColor.light.main,
  fontWeight: baseProperties.fontSizeSM,
};

const typographyLight = {
  fontFamily: baseProperties.fontFamily,
  fontWeightLighter: baseProperties.fontWeightLighter,
  fontWeightLight: baseProperties.fontWeightLight,
  fontWeightRegular: baseProperties.fontWeightRegular,
  fontWeightMedium: baseProperties.fontWeightMedium,
  fontWeightBold: baseProperties.fontWeightBold,

  subtitle1: {
    fontFamily: baseProperties.fontFamily,
    fontSize: baseProperties.fontSizeXL,
    fontWeight: baseProperties.fontWeightLight,
    lineHeight: 1.625,
  },

  subtitle2: {
    fontFamily: baseProperties.fontFamily,
    fontSize: baseProperties.fontSizeMD,
    fontWeight: baseProperties.fontWeightRegular,
    lineHeight: 1.6,
    color: lightColor.dark.main,
  },

  body1: {
    fontFamily: baseProperties.fontFamily,
    fontSize: baseProperties.fontSizeXL,
    fontWeight: baseProperties.fontWeightRegular,
    lineHeight: 1.625,
  },

  body2: {
    fontFamily: baseProperties.fontFamily,
    fontSize: baseProperties.fontSizeMD,
    fontWeight: baseProperties.fontWeightBold,
    lineHeight: 1.6,
    color: lightColor.dark.main,
  },

  body3: {
    fontFamily: baseProperties.fontFamily,
    fontSize: baseProperties.fontSizeSM,
    fontWeight: baseProperties.fontWeightBold,
    lineHeight: 1.6,
    color: lightColor.dark.main,
  },

  button: {
    fontFamily: baseProperties.fontFamily,
    fontSize: baseProperties.fontSizeSM,
    fontWeight: baseProperties.fontWeightMedium,
    lineHeight: 1.5,
    textTransform: 'none',
  },

  caption: {
    fontFamily: baseProperties.fontFamily,
    fontSize: baseProperties.fontSizeXS,
    fontWeight: baseProperties.fontWeightLight,
    lineHeight: 1.25,
  },

  leftNav: {
    backgroundImage: 'linear-gradient(to bottom,#044457, #018F99)',
    color: lightColor.white.main,
  },

  tocSub: {
    fontSize: baseProperties.fontSizeSM,
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    color: lightColor.dark.main,
  },

  overline: {
    fontFamily: baseProperties.fontFamily,
  },

  h1: {
    ...baseHeadingPropertiesLight,
  },

  h2: {
    fontFamily: baseProperties.fontFamily,
    color: lightColor.dark.main,
    fontSize: `${pxToRem(14)} !important`,
    fontWeight: baseProperties.fontWeightMedium,
  },

  cardFooter: {
    fontFamily: baseProperties.fontFamily,
    color: lightColor.dark.main,
    fontSize: baseProperties.fontSizeSM,
  },

  size: {
    xxs: baseProperties.fontSizeXXS,
    xs: baseProperties.fontSizeXS,
    sm: baseProperties.fontSizeSM,
    md: baseProperties.fontSizeMD,
    lg: baseProperties.fontSizeLG,
    xl: baseProperties.fontSizeXL,
    '2xl': baseProperties.fontSize2XL,
    '3xl': baseProperties.fontSize3XL,
  },

  lineHeight: {
    sm: 1.25,
    md: 1.5,
    lg: 2,
  },
};

const typographyDark = {
  fontFamily: baseProperties.fontFamily,
  fontWeightLighter: baseProperties.fontWeightLighter,
  fontWeightLight: baseProperties.fontWeightLight,
  fontWeightRegular: baseProperties.fontWeightRegular,
  fontWeightMedium: baseProperties.fontWeightMedium,
  fontWeightBold: baseProperties.fontWeightBold,

  subtitle1: {
    fontFamily: baseProperties.fontFamily,
    fontSize: baseProperties.fontSizeXL,
    fontWeight: baseProperties.fontWeightLight,
    lineHeight: 1.625,
  },

  subtitle2: {
    fontFamily: baseProperties.fontFamily,
    fontSize: baseProperties.fontSizeMD,
    fontWeight: baseProperties.fontWeightLight,
    lineHeight: 1.6,
    color: darkColor.light.main,
  },

  body1: {
    fontFamily: baseProperties.fontFamily,
    fontSize: baseProperties.fontSizeXL,
    fontWeight: baseProperties.fontWeightRegular,
    lineHeight: 1.625,
  },

  body2: {
    fontFamily: baseProperties.fontFamily,
    fontSize: baseProperties.fontSizeMD,
    fontWeight: baseProperties.fontWeightLight,
    lineHeight: 1.6,
    color: darkColor.light.main,
  },

  body3: {
    fontFamily: baseProperties.fontFamily,
    fontSize: baseProperties.fontSizeSM,
    fontWeight: baseProperties.fontWeightLight,
    lineHeight: 1.6,
    color: darkColor.light.main,
  },

  button: {
    fontFamily: baseProperties.fontFamily,
    fontSize: baseProperties.fontSizeSM,
    fontWeight: baseProperties.fontWeightMedium,
    lineHeight: 1.5,
    textTransform: 'none',
  },

  caption: {
    fontFamily: baseProperties.fontFamily,
    fontSize: baseProperties.fontSizeXS,
    fontWeight: baseProperties.fontWeightLight,
    lineHeight: 1.25,
  },

  leftNav: {
    backgroundImage: 'linear-gradient(to bottom,#044457, #018F99)',
    color: lightColor.white.main,
  },

  tocSub: {
    fontSize: baseProperties.fontSizeSM,
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    color: darkColor.light.main,
  },

  overline: {
    fontFamily: baseProperties.fontFamily,
  },

  h1: {
    ...baseHeadingPropertiesDark,
  },

  h2: {
    fontFamily: baseProperties.fontFamily,
    color: darkColor.light.main,
    fontSize: `${pxToRem(14)} !important`,
    fontWeight: baseProperties.fontWeightMedium,
  },

  cardFooter: {
    fontFamily: baseProperties.fontFamily,
    fontSize: baseProperties.fontSizeSM,
    color: darkColor.light.main,
  },

  size: {
    xxs: baseProperties.fontSizeXXS,
    xs: baseProperties.fontSizeXS,
    sm: baseProperties.fontSizeSM,
    md: baseProperties.fontSizeMD,
    lg: baseProperties.fontSizeLG,
    xl: baseProperties.fontSizeXL,
    '2xl': baseProperties.fontSize2XL,
    '3xl': baseProperties.fontSize3XL,
  },

  lineHeight: {
    sm: 1.25,
    md: 1.5,
    lg: 2,
  },
};

export { typographyLight, typographyDark };
